import React from 'react'
import { Button, Spinner, Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import {
  MedicalRecordForm,
  MedicalRecordFormType,
} from 'models/MedicalRecord/MedicalRecordForm.type'

import { Header } from './components/Header'
import { useMedicalRecordForm } from './hooks/useMedicalRecordForm'
import { EvaluationView } from './sections/EvaluationView'
import { EvolutionView } from './sections/EvolutionView'
import { OutcomeView } from './sections/OutcomeView'

import * as S from './styles'

interface ViewMedicalRecordModalProps {
  onClose: () => void
  formUuid: string
  patientName: string
  scheduleCount: number
  planName?: string
}

interface FormSectionByTypeProps {
  form: MedicalRecordForm
}

function FormSectionByType({ form }: FormSectionByTypeProps): JSX.Element | null {
  switch (form.type) {
  case MedicalRecordFormType.TECHNICAL_EVALUATION:
    return <EvaluationView form={form} />
  case MedicalRecordFormType.EVOLUTION:
    return <EvolutionView form={form} />
  case MedicalRecordFormType.OUTCOME:
    return <OutcomeView form={form} />
  default:
    return null
  }
}

export function ViewMedicalRecordModal({
  onClose,
  formUuid,
  patientName,
  scheduleCount,
  planName,
}: ViewMedicalRecordModalProps): JSX.Element {
  const { form, isLoading, isError } = useMedicalRecordForm(formUuid)

  return (
    <ModalGeneric
      modalTitle='Ver prontuário'
      type='medium'
      onCloseModal={onClose}
      hasTopBarActive={false}
    >
      <S.ModalContent>
        {isLoading && (
          <S.StateWrapper>
            <Spinner />
            <Typography variant='content2'>Carregando prontuário...</Typography>
          </S.StateWrapper>
        )}

        {isError && (
          <S.StateWrapper>
            <Typography variant='content2' weight='bold'>
              Não foi possível carregar o prontuário.
            </Typography>
            <Typography variant='content3'>
              Tente novamente em alguns instantes.
            </Typography>
          </S.StateWrapper>
        )}

        {!isLoading && !isError && form && (
          <>
            <Header
              patientName={patientName}
              sessionNumber={scheduleCount}
              formType={form.type}
              planName={planName}
              publishedAtUtc={form.published_at_utc}
            />
            <FormSectionByType form={form} />
            <S.CloseButtonWrapper>
              <Button onClick={onClose} variant='contained' uppercase={false}>
                Fechar
              </Button>
            </S.CloseButtonWrapper>
          </>
        )}
      </S.ModalContent>
    </ModalGeneric>
  )
}
